import React from "react";
import i18n from "../../../../localization/i18n";
import * as rk from "../../../../localization/resourceKeys";
import styles from "./wellsFargoBanner.module.scss";

export interface SpeedBumpState {
  title: string;
  text1: string;
  text2: string;
  externalLink: string;
}
export interface WellsFargoBannerProps {
  wellsFargoLoginUrl: string;
  wellsFargoFaqUrl: string;
  showSpeedBump: (state: SpeedBumpState) => void;
  enableAdobeAnalytics: boolean;
}

export const WellsFargoBanner: React.FC<WellsFargoBannerProps> = ({
  wellsFargoLoginUrl,
  wellsFargoFaqUrl,
  showSpeedBump,
  enableAdobeAnalytics,
}) => {
  return (
    <section
      id="wf-banner"
      data-testid="wf-banner"
      className={styles["c-notifications-group"]}
    >
      <div />
      <div className={styles["wellsFargo-baner"]}>
        <div className="c-notification__container">
          <div className={styles["c-notification"]} data-marketing-theme="2">
            <div className={styles["c-notification__outer-wrap"]}>
              <div className={styles["c-notification__inner-wrap"]}>
                <div className={styles["c-notification__content"]}>
                  <p className={styles["c-notification__query"]}>
                    {i18n.t(rk.TEXT_BANNER_MESSAGE_QUERY)}
                  </p>
                  <p className={styles["c-notification__info"]}>
                    {i18n.t(rk.TEXT_BANNER_MESSAGE_INFO)}{" "}
                    <a
                      id="wf-login-link-mobile"
                      data-test-id="log-in-external-link"
                      href="#"
                      onClick={(e) => {
                        // Send adobe analytics event.
                        if (enableAdobeAnalytics) {
                          const eventData = {
                            event: "link_click",
                            payload: {
                              linkUrlClicked: wellsFargoLoginUrl,
                              source: "portal-auth",
                              linkText: i18n.t(
                                rk.TEXT_BANNER_MESSAGE_LOGIN_LINK,
                              ),
                            },
                          };

                          if (window.adobeDataLayer) {
                            window.adobeDataLayer.push(eventData);
                          }
                        }
                        e.preventDefault();
                        showSpeedBump({
                          title: i18n.t(rk.TITLE_MODAL),
                          text1: i18n.t(rk.TEXT_MODAL1),
                          text2: i18n.t(rk.TEXT_MODAL2),
                          externalLink: wellsFargoLoginUrl,
                        });
                      }}
                      className={`${styles["c-notification__link"]}`}
                    >
                      {i18n.t(rk.TEXT_BANNER_MESSAGE_LOGIN_LINK)}                   
                    </a>
                    <span className={`${styles["login-link-period"]}`}>.</span>
                  </p>
                  <div className="WF-banner-block3">
                    <a
                      id="wf-login-link-desktop"
                      data-test-id="log-in-external-link"
                      href="#"
                      onClick={(e) => {
                        // Send adobe analytics event.
                        if (enableAdobeAnalytics) {
                          const eventData = {
                            event: "link_click",
                            payload: {
                              linkUrlClicked: wellsFargoLoginUrl,
                              source: "portal-auth",
                              linkText: i18n.t(
                                rk.TEXT_BANNER_MESSAGE_LOGIN_LINK,
                              ),
                            },
                          };

                          if (window.adobeDataLayer) {
                            window.adobeDataLayer.push(eventData);
                          }
                        }
                        e.preventDefault();
                        showSpeedBump({
                          title: i18n.t(rk.TITLE_MODAL),
                          text1: i18n.t(rk.TEXT_MODAL1),
                          text2: i18n.t(rk.TEXT_MODAL2),
                          externalLink: wellsFargoLoginUrl,
                        });
                      }}
                      className={`${styles["c-notification__link1"]}`}
                    >
                      {i18n.t(rk.TEXT_BANNER_MESSAGE_LOGIN_LINK)}
                    </a>
                    <span className={`${styles["login-link-period1"]}`}>. </span>
                    <span className="c-notification__info">
                      {i18n.t(rk.TEXT_BANNER_MESSAGE_QUESTION)}
                    </span>
                    <a
                      id="wf-browse-faqs-link"
                      data-test-id="faq-external-link"
                      href="#"
                      onClick={(e) => {
                        // Send adobe analytics event.
                        if (enableAdobeAnalytics) {
                          const eventData = {
                            event: "link_click",
                            payload: {
                              linkUrlClicked: wellsFargoFaqUrl,
                              source: "portal-auth",
                              linkText: i18n.t(rk.TEXT_BANNER_MESSAGE_BROWSE),
                            },
                          };

                          if (window.adobeDataLayer) {
                            window.adobeDataLayer.push(eventData);
                          }
                        }
                        e.preventDefault();
                        showSpeedBump({
                          title: i18n.t(rk.TITLE_MODAL),
                          text1: i18n.t(rk.TEXT_MODAL1),
                          text2: i18n.t(rk.TEXT_MODAL2),
                          externalLink: wellsFargoFaqUrl,
                        });
                      }}
                      className={`${styles["c-notification__link"]}`}
                    >
                      {i18n.t(rk.TEXT_BANNER_MESSAGE_BROWSE)}                    
                    </a>
                    <span>. </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
